import { FC } from "react";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import { Navigate } from "react-router-dom";
import { useRouteParams } from "app/route/route";
import { deleteReportVersionAccessInformationFileRoute, reportVersionAccessInformationRoute } from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { useDeleteReportAccessInformationFileMutation, useReportAccessInformationFileQuery } from "app/api/graph/types";
import { reportAccessInformationFileGraphId } from "app/api/graph/helpers";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { ConfirmDelete } from "app/component/form/ConfirmDelete";

export const DeleteReportVersionAccessInformationFileScreen: FC = () => {
    const { reportId, versionId, fileId } = useRouteParams(deleteReportVersionAccessInformationFileRoute);
    const { data, loading, error } = useReportAccessInformationFileQuery({
        variables: { fileId: reportAccessInformationFileGraphId(fileId) },
    });
    const [deleteFile, { data: deleteData, loading: deleting, error: deleteError }] =
        useDeleteReportAccessInformationFileMutation({
            variables: { input: { id: reportAccessInformationFileGraphId(fileId) } },
        });
    const file = data?.reportAccessInformationFile;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!file) {
        return <ErrorScreen title="Error" message="Not found." />;
    }
    if (deleteData?.deleteReportAccessInformationFile) {
        return <Navigate to={reportVersionAccessInformationRoute.build({ reportId, versionId })} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={deleteReportVersionAccessInformationFileRoute} />
                <h1>{file.reportMediaObject.originalName}</h1>
                {deleteError ? <Alert variant="danger">{deleteError.message}</Alert> : null}
                <p>Are you sure that you want to permanently delete this file from this report version?</p>
                <ConfirmDelete onConfirm={() => deleteFile()} deleting={deleting} />
            </Container>
        </NavigationScreen>
    );
};
